module.exports = __webpack_public_path__ + "static/media/logo-arbitr-mobile.1b0e4f83.svg";